import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components/macro";

import { Grid as MuiGrid, Input } from "@material-ui/core";

import { spacing } from "@material-ui/system";

import { useQuery } from "react-query";
import { findRawRecords } from "../../../services/crudService";
import useService from "../../../hooks/useService";
import DataAdminTable from "../../../components/DataAdminTable";
import Loader from "../../../components/Loader";
import Panel from "../../../components/panels/Panel";
import DatePicker from "../../../components/pickers/DatePicker";
import { add } from "date-fns";
import moment from "moment";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

const TableWrapper = styled.div`
  overflow-y: auto;
  max-width: calc(100vw - ${(props) => props.theme.spacing(12)}px);
  height: 100%;
  width: 100%;
`;

const Grid = styled(MuiGrid)(spacing);

function StaffGageReadings({ actions = [] }) {
  const service = useService({ toast: false });

  //date filter defaults
  const defaultFilterValues = {
    // startDate: lastOfJanuary,
    startDate: null,
    endDate: new Date(),
  };
  const [filterValues, setFilterValues] = useState(defaultFilterValues);
  const changeFilterValues = (name, value) => {
    setFilterValues((prevState) => {
      let newFilterValues = { ...prevState };
      newFilterValues[name] = value;
      return newFilterValues;
    });
  };

  const filterDataByDateFilters = (data) => {
    return data?.filter(
      (item) =>
        new Date(item.collect_timestamp) > filterValues.startDate &&
        new Date(item.collect_timestamp) <
          add(filterValues.endDate, { days: 1 })
    );
  };

  const [filteredData, setFilteredData] = useState(null);
  const {
    data: unfilteredData,
    isLoading,
    // error,
  } = useQuery(
    ["DataStaffGageReadings"],
    async () => {
      try {
        const response = await service([
          findRawRecords,
          ["DataStaffGageReadings"],
        ]);
        return response;
      } catch (err) {
        console.error(err);
      }
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    const filterData = filterDataByDateFilters(unfilteredData);
    setFilteredData(filterData);
  }, [filterValues, unfilteredData]); //eslint-disable-line

  const { data: Stations } = useQuery(
    ["ListMeasurementStationsUps"],
    async () => {
      try {
        return await service([findRawRecords, ["ListMeasurementStationsUps"]]);
      } catch (err) {
        console.error(err);
      }
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );

  const formattedStations = useMemo(() => {
    let converted = {};
    if (Stations?.length > 0) {
      Stations.forEach((d) => {
        converted[d.station_ndx] = d.map_display_name;
      });
    }
    return converted;
  }, [Stations]);

  const columns = [
    {
      title: "Station",
      field: "station_ndx",
      lookup: formattedStations,
    },
    {
      title: "Collected",
      field: "collect_timestamp",
      initialEditValue: new Date(),
      type: "datetime",
      editComponent: (props) => (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DateTimePicker
            format="MM/dd/yyyy, h:mm a"
            value={props.value || null}
            onChange={props.onChange}
            clearable
            InputProps={{
              style: {
                fontSize: 13,
              },
            }}
          />
        </MuiPickersUtilsProvider>
      ),
      render: (rowData) => {
        return moment(rowData.collect_timestamp).format("MMM D YYYY, hh:mm a");
      },
      // cellStyle: { maxWidth: "100%" },
    },
    {
      title: "Measurement",
      field: "measured_value",
      type: "numeric",
      initialEditValue: 0,
      validate: (rowData) =>
        isNaN(rowData.measured_value)
          ? {
              isValid: false,
              helperText: "A measured value is required",
            }
          : rowData.measured_value < 0
          ? {
              isValid: false,
              helperText: "The measured value cannot be negative",
            }
          : true,
      width: "0%",
    },
    {
      title: "Notes",
      field: "notes",
      editComponent: (props) => (
        <Input
          defaultValue={props.value ?? ""}
          onChange={(e) => props.onChange(e.target.value)}
          type="text"
          style={{ width: "100%" }}
        />
      ),
    },
  ];

  return (
    <React.Fragment>
      <Panel>
        <Grid container spacing={6}>
          <Grid item xs={12} sm={6}>
            <DatePicker
              label="Start Date"
              name="startDate"
              selectedDate={filterValues.startDate}
              setSelectedDate={changeFilterValues}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              label="End Date"
              name="endDate"
              selectedDate={filterValues.endDate}
              setSelectedDate={changeFilterValues}
            />
          </Grid>
        </Grid>
        {filteredData ? (
          <TableWrapper>
            <DataAdminTable
              pageSize={10}
              isLoading={isLoading}
              label="Staff Gage Readings"
              columns={columns}
              data={filteredData}
              height="350px"
              updateHandler={setFilteredData}
              endpoint="data-staff-gage-readings"
              actions={actions}
            />
          </TableWrapper>
        ) : (
          <Loader />
        )}
      </Panel>
    </React.Fragment>
  );
}

export default StaffGageReadings;
